import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from './Model';

export interface IAdditionalInfoLabelModel extends IModel {
  additionalInfoLabelId: number;
  name: string;
  information: string;
}

export class AdditionalInfoLabelModel
  extends Model
  implements ModelRecord<IAdditionalInfoLabelModel>
{
  additionalInfoLabelId: number;
  name: string;
  information: string;

  constructor(params?: Partial<IAdditionalInfoLabelModel>) {
    super(params);
    this.additionalInfoLabelId = defaultTo(params?.additionalInfoLabelId, 0);
    this.name = defaultTo(params?.name, '');
    this.information = defaultTo(params?.information, '');
  }
}
